const SubAbasInformes = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/adm/informes/ficha/${id}/dadosgerais`,
  },
];

export default SubAbasInformes;
